import React, {useEffect, useState} from 'react';
import {inject, observer} from 'mobx-react';
import GenerateAiAssistantStore from '../store/GenerateAiAssistantStore';
import GenerateAIAssistantUI from '../view/GenerateAIAssistantUI';
import {useNavigate, useParams} from 'react-router-dom';
import {
  CreateAiAssistantModel,
  FetchCoursesShortListModel,
} from '../../../../data/models/AI/AiAssistantModels';
import NavigationStore from '../../../../navigation/store/NavigationStore';
import {OrganizationDetails} from '../../../../data/models/Oganization/Organization';
import {useClarityPageView} from '../../../../utils/useClarityPageView';

interface Props {
  generateAiAssistantStore?: GenerateAiAssistantStore;
  navigationStore?: NavigationStore;
}

const GenerateAiAssistantContainer: React.FC = inject(
  'generateAiAssistantStore',
  'navigationStore',
)(
  observer(({generateAiAssistantStore, navigationStore}: Props) => {
    const [search, setSearch] = useState('');
    const [courses, setCourses] = useState<FetchCoursesShortListModel[]>([]);
    const [myOrganization, setMyOrganization] = useState<OrganizationDetails>();

    const {organizationId} = useParams();
    const navigate = useNavigate();

    useClarityPageView('/manage/home/ai_assistant', 'staff');

    const fetchCourses = async (text: string): Promise<void> => {
      try {
        if (organizationId) {
          const data = await generateAiAssistantStore!.getCoursesList(
            organizationId,
            text,
          );
          setCourses(data);
        }
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

    useEffect(() => {
      fetchCourses(search);
      if (navigationStore!.userOrganization) {
        setMyOrganization(navigationStore!.userOrganization);
      }
    }, [organizationId]);

    useEffect(() => {
      fetchCourses(search);
    }, [search]);

    const onSave = async (model: CreateAiAssistantModel, avatar?: File) => {
      if (organizationId) {
        const success = await generateAiAssistantStore!.createAiAssistant(
          organizationId,
          model,
          avatar,
        );
        if (success) {
          onCancel();
        }
      }
    };

    const onCancel = () => {
      navigate(`/manage/${organizationId}/home/ai_assistant`, {replace: true});
    };

    return (
      <GenerateAIAssistantUI
        courses={courses}
        onSave={onSave}
        onCancel={onCancel}
        courseSearch={search}
        setSearchText={setSearch}
        isLoading={generateAiAssistantStore!.isLoading}
        organizationAvatar={myOrganization?.avatar}
      />
    );
  }),
);

export default GenerateAiAssistantContainer;
